import { buildPolicyHook, useCurrentUserDataLifecycle } from 'policy-lib';
import { EnrichmentPolicy } from './EnrichmentPolicy';
import { useEnrichmentSettings } from '../EnrichmentSettingsProvider';
const useBaseEnrichmentPolicy = buildPolicyHook(EnrichmentPolicy);

/**
 * Get access to the enrichment policy tied to the current user.
 *
 * @returns {object} {EnrichmentPolicy, refresh}
 */
export function useEnrichmentPolicyNext() {
  const {
    settings,
    isLoaded
  } = useEnrichmentSettings();
  const {
    isRefreshing,
    refresh
  } = useCurrentUserDataLifecycle();
  const policy = useBaseEnrichmentPolicy({
    settings,
    isLoaded
  });
  return {
    isLoading: !policy.isLoaded,
    isRefreshing,
    policy,
    refresh
  };
}